module.exports = __webpack_public_path__ + "img/STOVE_AMENITY.d7efaae4.svg";